// src/utils/storage.js

export const storage = {
  // Generic storage methods
  getItem: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.warn(`Failed to get item '${key}':`, error);
      return null;
    }
  },
  
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.warn(`Failed to set item '${key}':`, error);
      return false;
    }
  },
  
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.warn(`Failed to remove item '${key}':`, error);
      return false;
    }
  },
  
  // Auth-specific methods (NO TOKEN STORAGE)
  setUser: (user) => {
    try {
      sessionStorage.setItem('medigo_user', JSON.stringify(user));
    } catch (error) {
      console.warn('Failed to save user:', error);
    }
  },
  
  getUser: () => {
    try {
      const user = sessionStorage.getItem('medigo_user');
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.warn('Failed to get user:', error);
      return null;
    }
  },
  
  removeUser: () => {
    try {
      sessionStorage.removeItem('medigo_user');
    } catch (error) {
      console.warn('Failed to remove user:', error);
    }
  },
  
  // Location-specific methods
  setLocation: (location) => {
    try {
      localStorage.setItem('medigo_location', JSON.stringify(location));
    } catch (error) {
      console.warn('Failed to save location:', error);
    }
  },
  
  getLocation: () => {
    try {
      const location = localStorage.getItem('medigo_location');
      return location ? JSON.parse(location) : null;
    } catch (error) {
      console.warn('Failed to get location:', error);
      return null;
    }
  },
  
  removeLocation: () => {
    try {
      localStorage.removeItem('medigo_location');
    } catch (error) {
      console.warn('Failed to remove location:', error);
    }
  },
  
  // Preferences methods
  setPreferences: (preferences) => {
    try {
      localStorage.setItem('medigo_preferences', JSON.stringify(preferences));
    } catch (error) {
      console.warn('Failed to save preferences:', error);
    }
  },
  
  getPreferences: () => {
    try {
      const preferences = localStorage.getItem('medigo_preferences');
      return preferences ? JSON.parse(preferences) : null;
    } catch (error) {
      console.warn('Failed to get preferences:', error);
      return null;
    }
  },
  
  removePreferences: () => {
    try {
      localStorage.removeItem('medigo_preferences');
    } catch (error) {
      console.warn('Failed to remove preferences:', error);
    }
  },
  
  // Theme methods
  setTheme: (theme) => {
    try {
      localStorage.setItem('medigo_theme', theme);
    } catch (error) {
      console.warn('Failed to save theme:', error);
    }
  },
  
  getTheme: () => {
    try {
      return localStorage.getItem('medigo_theme');
    } catch (error) {
      console.warn('Failed to get theme:', error);
      return null;
    }
  },
  
  removeTheme: () => {
    try {
      localStorage.removeItem('medigo_theme');
    } catch (error) {
      console.warn('Failed to remove theme:', error);
    }
  },
  
  // Clear all app data
  clear: () => {
    try {
      sessionStorage.removeItem('medigo_user');
      localStorage.removeItem('medigo_location');
      localStorage.removeItem('medigo_preferences');
      localStorage.removeItem('medigo_theme');
    } catch (error) {
      console.warn('Failed to clear storage:', error);
    }
  },
  
  // Clear only auth data (no token to clear - it's in httpOnly cookie)
  clearAuth: () => {
    try {
      sessionStorage.removeItem('medigo_user');
    } catch (error) {
      console.warn('Failed to clear auth data:', error);
    }
  },
  
  // Check if storage is available
  isAvailable: () => {
    try {
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }
};